function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.49,
    height: 42.954,
    viewBox: "0 0 58.49 42.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23984"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23602",
    d: "M57.633 68.854a2.924 2.924 0 0 0-4.136 0L18.46 103.892 4.992 90.424A2.924 2.924 0 0 0 .856 94.56l15.536 15.54a2.925 2.925 0 0 0 4.136 0l37.105-37.11a2.924 2.924 0 0 0 0-4.136z",
    transform: "translate(0 -67.997)",
    style: {
      fill: "#5e1e63"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.31dd1a09c7ecd92b9b33683dad3eb325.svg";
export { ForwardRef as ReactComponent };